<template>
  <div
    class="flex overflow-hidden flex-col items-center py-[60px] px-[15px] md:py-[100px] bg-black"
  >
    <div
      v-text="$t('common.warranty_conditions')"
      class="font-ff-good-pro-cond text-white text-[22px] leading-8 lg:text-4xl lg:leading-[46px] uppercase font-bold mb-4 md:mb-10"
    ></div>
    <!-- Main Wrapper for Both Sections -->
    <div class="grid grid-cols-1 gap-6 md:container md:grid-cols-2">
      <div
        class="rounded-md bg-[#373737]"
        data-aos="fade-right"
        data-aos-delay="100"
        data-aos-offset="50"
      >
        <div class="md:px-10 md:pt-10 md:pb-[60px] pt-5 px-5">
          <div
            class="text-[#FF212A] mb-1 md:mb-[10px] font-ff-good-pro-cond text-[22px] leading-7 md:text-4xl md:leading-[46px] font-bold uppercase text-left"
            v-text="$t('common.5_years')"
          ></div>
          <p
            class="text-white font-ff-good-pro-cond text-[22px] leading-[30px] md:text-[34px] font-normal md:leading-[35px] text-left"
          >
            {{ $t("common.warranty_full_text") }}
            {{ $t("common.warranty_carbon_text") }}
            {{ $t("common.carbon_description") }}
          </p>
        </div>
        <div
          class="opacity-90 mt-[9px] md:mt-0"
          style="
            background: linear-gradient(
              203deg,
              rgba(0, 0, 0, 0) 39.41%,
              rgba(0, 0, 0, 0.8) 100%
            );
          "
        >
          <img
            src="/warranty/warranty_5_years.png"
            alt="warranty 5 years"
            class="flex items-center justify-center w-full h-[414px] lg:h-[620px] max-h-[620px]"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
      </div>
      <div
        class="rounded-md bg-[#373737]"
        data-aos="fade-left"
        data-aos-delay="100"
        data-aos-offset="50"
      >
        <div class="md:px-10 md:pt-10 md:pb-[60px] pt-5 px-5">
          <div
            v-text="$t('common.2_years')"
            class="text-[#FF212A] mb-1 md:mb-[10px] font-ff-good-pro-cond text-[22px] leading-7 md:text-4xl md:leading-[46px] font-bold uppercase text-left"
          ></div>
          <p
            class="text-white font-ff-good-pro-cond text-[22px] leading-[30px] md:text-[34px] md:leading-[35px] font-normal text-left"
          >
            {{ $t("common.warranty_full_text") }}
            {{ $t("common.warranty_aluminum_text") }}
            {{ $t("common.aluminum_description") }}
          </p>
        </div>
        <div
          class="opacity-90 mt-[9px] md:mt-0"
          style="
            background: linear-gradient(
              203deg,
              rgba(0, 0, 0, 0) 39.41%,
              rgba(0, 0, 0, 0.8) 100%
            );
          "
        >
          <img
            src="/warranty/warranty_2_years.png"
            class="self-center object-cover w-full h-[414px] lg:h-[620px]"
            alt="warranty 5 years"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <!-- Second Section: 1 Year and Images -->
    <div class="md:container">
      <div
        class="bg-[#373737] rounded-md p-5 lg:p-10 w-full mt-6 flex flex-col"
      >
        <!-- Heading -->
        <div
          v-text="$t('common.1_year')"
          class="text-[#FF212A] mb-4 md:mb-7 font-ff-good-pro-cond font-bold text-[22px] leading-7 lg:text-4xl lg:leading-[46px] uppercase text-left"
        ></div>

        <!-- Images Grid (2 Rows with 3 Images Each) -->
        <div
          class="grid w-full grid-cols-1 lg:grid-cols-3 lg:gap-6 lg:justify-items-center"
        >
          <!-- Image 1 -->
          <div class="flex flex-col">
            <h2
              v-text="$t('common.decals_text')"
              class="lg:mb-[10px] mt-6 lg:mt-0 mb-1 text-lg lg:text-xl leading-[26px] font-normal text-left text-white font-ff-good-pro-cond"
            ></h2>
            <img
              src="@/public/warranty/warranty_condition_3.png"
              alt="Image 1"
              class="w-full h-[305px] lg:w-[313px] lg:h-[314px] object-cover"
            />
          </div>

          <!-- Image 2 -->
          <div class="flex flex-col">
            <h2
              v-text="$t('common.component2_text')"
              class="lg:mb-[10px] mt-6 lg:mt-0 mb-1 text-lg lg:text-xl leading-[26px] font-normal text-left text-white font-ff-good-pro-cond"
            ></h2>
            <img
              src="@/public/warranty/warranty_condition_4.png"
              alt="Image 2"
              class="w-full h-[305px] lg:w-[313px] lg:h-[314px] object-cover"
            />
          </div>

          <!-- Image 3 -->
          <div class="flex flex-col">
            <h2
              v-text="$t('common.carbon_text')"
              class="lg:mb-[10px] mt-6 lg:mt-0 mb-1 text-lg lg:text-xl leading-[26px] font-normal text-left text-white font-ff-good-pro-cond"
            ></h2>
            <img
              src="@/public/warranty/warranty_condition_5.png"
              alt="Image 3"
              class="w-full h-[305px] lg:w-[313px] lg:h-[314px] object-cover"
            />
          </div>
        </div>

        <div
          class="grid grid-cols-1 lg:gap-6 lg:grid-cols-3 lg:mt-9 lg:justify-items-center"
        >
          <!-- Image 4 -->
          <div class="flex flex-col">
            <h2
              v-text="$t('common.suspension_text')"
              class="lg:mb-[10px] mt-6 lg:mt-0 mb-1 text-lg lg:text-xl leading-[26px] font-normal text-left text-white font-ff-good-pro-cond"
            ></h2>
            <img
              src="@/public/warranty/warranty_condition_6.png"
              alt="Image 4"
              class="w-full h-[305px] lg:w-[313px] lg:h-[314px] object-cover"
            />
          </div>

          <!-- Image 5 -->
          <div class="flex flex-col">
            <h2
              v-text="$t('common.motor_text')"
              class="lg:mb-[10px] mt-6 lg:mt-0 mb-1 text-lg lg:text-xl leading-[26px] font-normal text-left text-white font-ff-good-pro-cond"
            ></h2>
            <img
              src="@/public/warranty/warranty_condition_7.png"
              alt="Image 5"
              class="w-full h-[305px] lg:w-[313px] lg:h-[314px] object-cover"
            />
          </div>

          <!-- Image 6 -->
          <div class="flex flex-col">
            <h2
              v-text="$t('common.electrical_text')"
              class="lg:mb-[10px] mt-6 lg:mt-0 mb-1 text-lg lg:text-xl leading-[26px] font-normal text-left text-white font-ff-good-pro-cond"
            ></h2>
            <img
              src="@/public/warranty/warranty_condition_8.png"
              alt="Image 6"
              class="w-full h-[305px] lg:w-[313px] lg:h-[314px] object-cover"
            />
          </div>
        </div>
        <div
          class="justify-center w-auto font-ff-good-pro-cond text-lg lg:text-xl leading-[26px] text-white mt-6 lg:mt-[40px]"
        >
          <ul class="my-0">
            <li v-text="$t('common.warranty_condition_1_year_list1')"></li>
            <li v-text="$t('common.warranty_condition_1_year_list2')"></li>
            <li v-html="$t('common.warranty_condition_1_year_terms')"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "YourComponent",
};
</script>

<style scoped>
/* Scoped styles if needed */
</style>
